import React from 'react';
import SkeletonItem from './components/ConversationItem/skeleton';

const Skeleton = () => {
  return (
    <>
      {[...Array(10)].map((_, idx) => {
        return <SkeletonItem key={idx} />;
      })}
    </>
  );
};

export default Skeleton;
